//src/components/ZaraChatWidget.js

export const FEEDBACK_RATINGS = [
  { val: 1, emoji: "😠", labelEn: "Very Bad", labelRu: "Bohat Bura" },
  { val: 2, emoji: "😕", labelEn: "Bad", labelRu: "Bura" },
  { val: 3, emoji: "😐", labelEn: "Okay", labelRu: "Theek Thaak" },
  { val: 4, emoji: "😊", labelEn: "Good", labelRu: "Acha" },
  { val: 5, emoji: "🤩", labelEn: "Excellent", labelRu: "Behtareen" },
];

export const FEEDBACK_CATEGORIES = [
  { id: "service_quality", labelEn: "Service Quality",  labelRu: "Service Ka Maiyar" },
  { id: "support_team",    labelEn: "Support Team",     labelRu: "Support Team" },
  { id: "app_experience",  labelEn: "App Experience",   labelRu: "App Ka Tajurba" },
  { id: "pricing",         labelEn: "Pricing",          labelRu: "Qeemat" },
  { id: "claims_process",  labelEn: "Claims Process",   labelRu: "Claims Ka Amal" },
  { id: "other",           labelEn: "Other",            labelRu: "Kuch Aur" },
];